import React from "react";
import { Alert, AlertTitle, Stack } from "@mui/material";

// custom components
import Heading5 from "../typography/heading-05";
import Body3 from "../typography/body-03";
import PrimaryButton from "../buttons/primary-button";

// custom styles
import styles from "./index.module.scss";

const CustomAlert = ({
	subject,
	details,
	severity = "info", // "error" | "warning" | "info" | "success"
	extraClass = "",
	onClose,
	variant = "outline", // "standard" | "filled" | "outlined"
	icon,
	showClearButton = false,
	onClearMessage,
	clearButtonText = "Clear Message",
}) => {
	// Combine custom styles with any extra classes
	const customClass = `${styles.customAlert} ${extraClass}`;

	return (
		<Alert
			severity={severity}
			variant={variant}
			className={customClass}
			onClose={onClose}
			icon={icon}
			sx={{
				"& .MuiAlert-message": {
					width: "100%",
					display: "flex",
				},
			}}
		>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				sx={{ width: "100%" }}
			>
				<Stack direction="column" spacing={1}>
					{subject && (
						<AlertTitle sx={{ mb: 0 }}>
							<Heading5
								text={subject}
								fontType="semibold"
								extraClass={styles.alertTitle}
							/>
						</AlertTitle>
					)}
					{details && <Body3 text={details} extraClass={styles.alertDetails} />}
				</Stack>
				{showClearButton && onClearMessage && (
					<Stack sx={{}}>
						<PrimaryButton
							text={clearButtonText}
							onClick={onClearMessage}
							disabled={false}
						/>
					</Stack>
				)}
			</Stack>
		</Alert>
	);
};

export default CustomAlert;
